module.exports = __webpack_public_path__ + "img/img1.9555a81c.png";